import { defineComponent as s, resolveComponent as i, openBlock as o, createElementBlock as r, Fragment as c, renderList as l, createVNode as _, withCtx as a, createElementVNode as p, createTextVNode as d, toDisplayString as u, createCommentVNode as m } from "vue";
import f from "../VLink/VLink.js";
import { _ as y } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../composables/useSpacingClass.js";
import "../../../utils/isExternalUrl.js";
const h = s({
  name: "VLinkList",
  components: { VLink: f },
  props: {
    links: {
      type: Array,
      default: () => []
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  }
});
const k = {
  key: 0,
  class: "hobi-link-list lg:tw-flex"
}, L = ["src", "alt"];
function V(t, b, g, v, x, C) {
  const n = i("VLink");
  return t.links.length ? (o(), r("ul", k, [
    (o(!0), r(c, null, l(t.links, (e) => (o(), r("li", {
      key: e.title
    }, [
      _(n, {
        class: "hobi-link-list__button",
        type: e.type,
        order: e.order,
        href: e.url,
        router: t.router
      }, {
        default: a(() => [
          p("img", {
            src: e.icon,
            alt: e.icon,
            class: "hobi-link-list__icon"
          }, null, 8, L),
          d(" " + u(e.title), 1)
        ]),
        _: 2
      }, 1032, ["type", "order", "href", "router"])
    ]))), 128))
  ])) : m("", !0);
}
const j = /* @__PURE__ */ y(h, [["render", V], ["__scopeId", "data-v-26b8ced8"]]);
export {
  j as default
};
